import { Injectable } from '@angular/core';


@Injectable()
export class AirportWebService {

  constructor() { }

  //public serverName: string = 'https://cwservicest.talgov.com'; // test
  public serverName: string = 'https://cwservices.talgov.com';  // prod
  //public serverName: string = 'http://localhost:10104';   // debug


  // url for calls to MVC services
  public baseURL: string = this.serverName + '/cw';


  // public credentials: Credentials;
  // public authToken: AuthToken;
}
